import { Component, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-modal-create-folder',
  templateUrl: './modal-create-folder.component.html',
  imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, TranslocoPipe],
})
export class ModalCreateFolderComponent implements OnInit {
  dialogRef = inject(MatDialogRef<ModalCreateFolderComponent>);
  data = inject<{ name?: string }>(MAT_DIALOG_DATA);

  nameControl = new FormControl('', [Validators.required, Validators.maxLength(100)]);

  ngOnInit(): void {
    if (this.data.name) {
      this.nameControl.setValue(this.data.name);
    }
  }

  confirm(): void {
    if (this.nameControl.valid) {
      this.dialogRef.close(this.nameControl.value);
    }
  }
}
